// extracted by mini-css-extract-plugin
export default {"main":"index_main__8M0+9","mainTitle":"index_mainTitle__mBtb6","mainSearch":"index_mainSearch__2KFbX","tree":"index_tree__aZ7lQ","treeBox":"index_treeBox__u3QV1"};